import ImageGallery from './image-gallery'
export default ImageGallery
